module.exports = __webpack_public_path__ + "img/page11-min.0c6225eb.jpg";